import { render, staticRenderFns } from "./RuleAdd.vue?vue&type=template&id=3b0e83af&"
import script from "./RuleAdd.vue?vue&type=script&lang=ts&"
export * from "./RuleAdd.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports